import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import uuid from "react-uuid";
import { makeStyles, withStyles } from "@mui/styles";
import {
  CustomSelect,
  TextInput,
  FloatInput,
  IntInput,
} from "components/Input/Index.js";
import AutocompleteTagsInput from "components/Input/AutocompleteTagsInput.js";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import DateInput from "components/Input/DateInput.js";
import CreateButton from "components/CustomButtons/CreateButton.js";
import { batiment } from "variables/patrimoine.js";
import { appareil, getObjectFromId } from "variables/lists/patrimoine.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { ActionContext } from "context/ActionContext";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Divider from "@mui/material/Divider";
import ImageList from "@mui/material/ImageList";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { getFiles, getSite } from "services/ConfigServices";
import { NotificationManager } from "react-notifications";

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "10%",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "10%",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

function AddContractDialog(props) {
  const [value, setValue] = useState("0");
  const [prevData, setPrevData] = useState();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [name, setName] = useState("");
  const [clef, setClef] = useState("");
  const [category, setCategory] = useState("");
  const [system, setSystem] = useState("");
  const [type, setType] = useState("");
  const [status, setStatus] = useState("");
  const [localization, setLocalization] = useState("");
  const [energysource, setEnergysource] = useState("");
  const [installationdate, setInstallationdate] = useState("");
  const [divisionunit, setDivisionunit] = useState("");
  const [consumptionpart, setConsumptionpart] = useState("");
  const [billingpart, setBillingpart] = useState("");
  const [productionpart, setProductionpart] = useState("");
  const [averageusageperiod, setAverageusageperiod] = useState("");
  const [averageusagetime, setAverageusagetime] = useState("");
  const [usagefrequency, setUsagefrequency] = useState("");
  const [defaultsetpoint, setDefaultsetpoint] = useState("");
  const [weighting, setWeighting] = useState("");
  const [efficiency, setEfficiency] = useState("");
  const [device, setDevice] = useState("");
  const [devicekey, setDevicekey] = useState("");
  const [devicename, setDevicename] = useState("");
  const [devicecategory, setDevicecategory] = useState("");
  const [devicetechnology, setDevicetechnology] = useState("");
  const [devicemodel, setDevicemodel] = useState("");
  const [devicecaracteristicval, setDevicecaracteristicval] = useState("");
  const [devicecaracteristicunit, setDevicecaracteristicunit] = useState("");
  const [devicerenewalrateflow, setDevicerenewalrateflow] = useState("");
  const [deviceelectricalpower, setDeviceelectricalpower] = useState("");
  const [devicethermicalpower, setDevicethermicalpower] = useState("");
  const [devicecoldpower, setDevicecoldpower] = useState("");
  const [devicecop, setDevicecop] = useState("");
  const [deviceefficiency, setDeviceefficiency] = useState("");
  const [devicerateflow, setDevicerateflow] = useState("");
  const [devicedimension, setDevicedimension] = useState("");
  const [devicevalve, setDevicevalve] = useState("");
  const [devicecarbonfootprint, setDevicecarbonfootprint] = useState("");
  const [devicegreyenergy, setDevicegreyenergy] = useState("");
  const [performancegrade, setPerformancegrade] = useState("");
  const [performancecomment, setPerformancecomment] = useState("");
  const [dilapidationgrade, setDilapidationgrade] = useState("");
  const [dilapidationcomment, setDilapidationcomment] = useState("");
  const [otherproperties, setOtherproperties] = useState([]);
  const [associatedfiles, setAssociatedfiles] = useState("");
  const [comments, setComments] = useState("");
  const [description, setDescription] = useState("");

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;
  const actionContext = useContext(ActionContext);
  const { action, setAction } = actionContext;

  const { closeModal, refetch, deleteCounter } = props;

  const handleNameChange = (event) => {
    setName(event.target.value);
  };
  const handleClefChange = (event) => {
    setClef(event.target.value);
  };
  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
  };
  const handleSystemChange = (event) => {
    setSystem(event.target.value);
  };
  const handleTypeChange = (event) => {
    setType(event.target.value);
  };
  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };
  const handleLocalizationChange = (event) => {
    setLocalization(event.target.value);
  };
  const handleEnergysourceChange = (event) => {
    setEnergysource(event.target.value);
  };
  const handleInstallationdateChange = (event) => {
    setInstallationdate(event.target.value);
  };
  const handleDivisionunitChange = (event) => {
    setDivisionunit(event.target.value);
  };
  const handleConsumptionpartChange = (event) => {
    setConsumptionpart(event.target.value);
  };
  const handleBillingpartChange = (event) => {
    setBillingpart(event.target.value);
  };
  const handleProductionpartChange = (event) => {
    setProductionpart(event.target.value);
  };
  const handleAverageusageperiodChange = (event) => {
    setAverageusageperiod(event.target.value);
  };
  const handleAverageusagetimeChange = (event) => {
    setAverageusagetime(event.target.value);
  };
  const handleUsagefrequencyChange = (event) => {
    setUsagefrequency(event.target.value);
  };
  const handleDefaultsetpointChange = (event) => {
    setDefaultsetpoint(event.target.value);
  };
  const handleWeightingChange = (event) => {
    setWeighting(event.target.value);
  };
  const handleEfficiencyChange = (event) => {
    setEfficiency(event.target.value);
  };
  const handleDeviceChange = (event) => {
    let appar = getObjectFromId(event.target.value, appareil);
    if (appar && appar.system && appar.system !== "") setSystem(appar.system);
    else setSystem("");
    if (appar && appar.devicecategory && appar.devicecategory !== "")
      setDevicecategory(appar.devicecategory);
    else setDevicecategory("");
    if (appar && appar.devicetechnology && appar.devicetechnology !== "")
      setDevicetechnology(appar.devicetechnology);
    else setDevicetechnology("");
    if (appar && appar.devicemodel && appar.devicemodel !== "")
      setDevicemodel(appar.devicemodel);
    else setDevicemodel("");
    if (
      appar &&
      appar.devicecaracteristicval &&
      appar.devicecaracteristicval !== ""
    )
      setDevicecaracteristicval(appar.devicecaracteristicval);
    else setDevicecaracteristicval("");
    if (
      appar &&
      appar.devicecaracteristicunit &&
      appar.devicecaracteristicunit !== ""
    )
      setDevicecaracteristicunit(appar.devicecaracteristicunit);
    else setDevicecaracteristicunit("");
    if (
      appar &&
      appar.devicerenewalrateflow &&
      appar.devicerenewalrateflow !== ""
    )
      setDevicerenewalrateflow(appar.devicerenewalrateflow);
    else setDevicerenewalrateflow("");
    if (
      appar &&
      appar.deviceelectricalpower &&
      appar.deviceelectricalpower !== ""
    )
      setDeviceelectricalpower(appar.deviceelectricalpower);
    else setDeviceelectricalpower("");
    if (
      appar &&
      appar.devicethermicalpower &&
      appar.devicethermicalpower !== ""
    )
      setDevicethermicalpower(appar.devicethermicalpower);
    else setDevicethermicalpower("");
    if (appar && appar.devicecoldpower && appar.devicecoldpower !== "")
      setDevicecoldpower(appar.devicecoldpower);
    else setDevicecoldpower("");
    if (appar && appar.devicecop && appar.devicecop !== "")
      setDevicecop(appar.devicecop);
    else setDevicecop("");
    if (appar && appar.deviceefficiency && appar.deviceefficiency !== "")
      setDeviceefficiency(appar.deviceefficiency);
    else setDeviceefficiency("");
    if (appar && appar.devicerateflow && appar.devicerateflow !== "")
      setDevicerateflow(appar.devicerateflow);
    else setDevicerateflow("");
    if (appar && appar.devicedimension && appar.devicedimension !== "")
      setDevicedimension(appar.devicedimension);
    else setDevicedimension("");
    if (appar && appar.devicevalve && appar.devicevalve !== "")
      setDevicevalve(appar.devicevalve);
    else setDevicevalve("");
    if (
      appar &&
      appar.devicecarbonfootprint &&
      appar.devicecarbonfootprint !== ""
    )
      setDevicecarbonfootprint(appar.devicecarbonfootprint);
    else setDevicecarbonfootprint("");
    if (appar && appar.devicegreyenergy && appar.devicegreyenergy !== "")
      setDevicegreyenergy(appar.devicegreyenergy);
    else setDevicegreyenergy("");
    setDevice(event.target.value);
  };
  const handleDevicekeyChange = (event) => {
    setDevicekey(event.target.value);
  };
  const handleDevicenameChange = (event) => {
    setDevicename(event.target.value);
  };
  const handleDevicecategoryChange = (event) => {
    setDevicecategory(event.target.value);
  };
  const handleDevicetechnologyChange = (event) => {
    setDevicetechnology(event.target.value);
  };
  const handleDevicemodelChange = (event) => {
    setDevicemodel(event.target.value);
  };
  const handleDevicecaracteristicvalChange = (event) => {
    setDevicecaracteristicval(event.target.value);
  };
  const handleDevicecaracteristicunitChange = (event) => {
    setDevicecaracteristicunit(event.target.value);
  };
  const handleDevicerenewalrateflowChange = (event) => {
    setDevicerenewalrateflow(event.target.value);
  };
  const handleDeviceelectricalpowerChange = (event) => {
    setDeviceelectricalpower(event.target.value);
  };
  const handleDevicethermicalpowerChange = (event) => {
    setDevicethermicalpower(event.target.value);
  };
  const handleDevicecoldpowerChange = (event) => {
    setDevicecoldpower(event.target.value);
  };
  const handleDevicecopChange = (event) => {
    setDevicecop(event.target.value);
  };
  const handleDeviceefficiencyChange = (event) => {
    setDeviceefficiency(event.target.value);
  };
  const handleDevicerateflowChange = (event) => {
    setDevicerateflow(event.target.value);
  };
  const handleDevicedimensionChange = (event) => {
    setDevicedimension(event.target.value);
  };
  const handleDevicevalveChange = (event) => {
    setDevicevalve(event.target.value);
  };
  const handleDevicecarbonfootprintChange = (event) => {
    setDevicecarbonfootprint(event.target.value);
  };
  const handleDevicegreyenergyChange = (event) => {
    setDevicegreyenergy(event.target.value);
  };
  const handlePerformancegradeChange = (event) => {
    setPerformancegrade(event.target.value);
  };
  const handlePerformancecommentChange = (event) => {
    setPerformancecomment(event.target.value);
  };
  const handleDilapidationgradeChange = (event) => {
    setDilapidationgrade(event.target.value);
  };
  const handleDilapidationcommentChange = (event) => {
    setDilapidationcomment(event.target.value);
  };
  const handleOtherpropertiesChange = (newvalue) => {
    setOtherproperties(newvalue);
  };
  const handleAssociatedfilesChange = (newValue) => {
    setAssociatedfiles(newValue);
  };
  const handleCommentsChange = (event) => {
    setComments(event.target.value);
  };
  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };

  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  const selectedGed = () => {
    let gedCardId = [];
    let getGedNames;
    if (associatedfiles !== undefined) {
      for (let i = 0; i < associatedfiles.length; i++) {
        gedCardId.push(associatedfiles[i].fileId);
      }
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    return getGedNames;
  };
  useEffect(() => {
    axios
      .get(getFiles(chartIdGroup), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  useEffect(() => {
    axios
      .get(getSite(chartIdGroup, "equipments.equipmentlist"), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        setPrevData(res.data.detail?.equipments?.equipmentlist || []);
      });
  }, [deleteCounter]);

  const handleSubmit = async (event) => {
    let equipments = [...action.parameters.impact.equipments];
    const newEquipment = {
      name,
      clef,
      category,
      system,
      type,
      status,
      localization,
      energysource,
      installationdate,
      divisionunit,
      consumptionpart,
      billingpart,
      productionpart,
      averageusageperiod,
      averageusagetime,
      usagefrequency,
      defaultsetpoint,
      weighting,
      efficiency,
      device,
      devicekey,
      devicename,
      devicecategory,
      devicetechnology,
      devicemodel,
      devicecaracteristicval,
      devicecaracteristicunit,
      devicerenewalrateflow,
      deviceelectricalpower,
      devicethermicalpower,
      devicecoldpower,
      devicecop,
      deviceefficiency,
      devicerateflow,
      devicedimension,
      devicevalve,
      devicecarbonfootprint,
      devicegreyenergy,
      performancegrade,
      performancecomment,
      dilapidationgrade,
      dilapidationcomment,
      otherproperties,
      associatedfiles,
      comments,
      description,
      isSelected: true,
      uuid: uuid(),
    };
    equipments.push(newEquipment);

    console.log(equipments);

    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters?.impact,
          equipments,
        },
      },
    }));
    closeModal();
    refetch();
  };

  const divisionUnitData = [
    { name: "%", id: "percent" },
    { name: "m²", id: "sqrmtr" },
    { name: "autre", id: "other" },
  ];

  const periodData = [
    { name: "Jour", id: "day" },
    { name: "Semaine", id: "week" },
    { name: "Mois", id: "month" },
    { name: "Année", id: "year" },
  ];

  const autocompleteOptions = [];

  const classes = useStyles();

  return (
    <TabContext value={value} className={classes.root}>
      <div className={classes.demo2}>
        <AppBar
          position="static"
          className={classes.demo3}
          style={{ boxShadow: "none", shadowColor: "red" }}
        >
          <StyledTabs
            value={value}
            onChange={handleChange}
            aria-label="styled tabs example"
            scrollButtons="auto"
          >
            <StyledTab label="Paramètres" value="0" />
            <StyledTab label="Appareil" value="1" />
          </StyledTabs>
          <Typography className={classes.padding} />
        </AppBar>
        <Divider variant="fullWidth" />
        <TabPanel value="0">
          <form className={classes.root}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <div>
                  <TextInput
                    inputTitle={batiment.equipments.equipmentlist.key}
                    textInput={clef}
                    handleTextInputChange={handleClefChange}
                  />

                  <TextInput
                    inputTitle={batiment.equipments.equipmentlist.name}
                    textInput={name}
                    handleTextInputChange={handleNameChange}
                  />

                  <TextInput
                    inputTitle={batiment.equipments.equipmentlist.category}
                    textInput={category}
                    handleTextInputChange={handleCategoryChange}
                  />

                  <TextInput
                    inputTitle={batiment.equipments.equipmentlist.system}
                    textInput={system}
                    handleTextInputChange={handleSystemChange}
                  />

                  <TextInput
                    inputTitle={batiment.equipments.equipmentlist.type}
                    textInput={type}
                    handleTextInputChange={handleTypeChange}
                  />

                  <TextInput
                    inputTitle={batiment.equipments.equipmentlist.status}
                    textInput={status}
                    handleTextInputChange={handleStatusChange}
                  />

                  <TextInput
                    inputTitle={batiment.equipments.equipmentlist.localization}
                    textInput={localization}
                    handleTextInputChange={handleLocalizationChange}
                  />

                  <TextInput
                    inputTitle={batiment.equipments.equipmentlist.energysource}
                    textInput={energysource}
                    handleTextInputChange={handleEnergysourceChange}
                  />

                  <DateInput
                    inputTitle={
                      batiment.equipments.equipmentlist.installationdate
                    }
                    dateInput={installationdate}
                    handleDateInputChange={handleInstallationdateChange}
                    specialType={"month"}
                  />

                  <CustomSelect
                    inputTitle={batiment.equipments.equipmentlist.divisionunit}
                    selectValue={divisionunit}
                    handleSelectValueChange={handleDivisionunitChange}
                    data={divisionUnitData}
                  />

                  <FloatInput
                    inputTitle={
                      batiment.equipments.equipmentlist.consumptionpart
                    }
                    floatInput={consumptionpart}
                    handleFloatInputChange={handleConsumptionpartChange}
                  />

                  <FloatInput
                    inputTitle={batiment.equipments.equipmentlist.billingpart}
                    floatInput={billingpart}
                    handleFloatInputChange={handleBillingpartChange}
                  />

                  <FloatInput
                    inputTitle={
                      batiment.equipments.equipmentlist.productionpart
                    }
                    floatInput={productionpart}
                    handleFloatInputChange={handleProductionpartChange}
                  />

                  <CustomSelect
                    inputTitle={
                      batiment.equipments.equipmentlist.averageusageperiod
                    }
                    selectValue={averageusageperiod}
                    handleSelectValueChange={handleAverageusageperiodChange}
                    data={periodData}
                  />

                  <IntInput
                    inputTitle={
                      batiment.equipments.equipmentlist.averageusagetime
                    }
                    intInput={averageusagetime}
                    handleIntInputChange={handleAverageusagetimeChange}
                  />

                  <TextInput
                    inputTitle={
                      batiment.equipments.equipmentlist.usagefrequency
                    }
                    textInput={usagefrequency}
                    handleTextInputChange={handleUsagefrequencyChange}
                  />

                  <TextInput
                    inputTitle={
                      batiment.equipments.equipmentlist.defaultsetpoint
                    }
                    textInput={defaultsetpoint}
                    handleTextInputChange={handleDefaultsetpointChange}
                  />

                  <FloatInput
                    inputTitle={batiment.equipments.equipmentlist.weighting}
                    floatInput={weighting}
                    handleFloatInputChange={handleWeightingChange}
                  />

                  <FloatInput
                    inputTitle={batiment.equipments.equipmentlist.efficiency}
                    floatInput={efficiency}
                    handleFloatInputChange={handleEfficiencyChange}
                  />

                  <TextInput
                    inputTitle={
                      batiment.equipments.equipmentlist.performancegrade
                    }
                    textInput={performancegrade}
                    handleTextInputChange={handlePerformancegradeChange}
                  />

                  <TextInput
                    inputTitle={
                      batiment.equipments.equipmentlist.performancecomment
                    }
                    textInput={performancecomment}
                    handleTextInputChange={handlePerformancecommentChange}
                  />

                  <TextInput
                    inputTitle={
                      batiment.equipments.equipmentlist.dilapidationgrade
                    }
                    textInput={dilapidationgrade}
                    handleTextInputChange={handleDilapidationgradeChange}
                  />

                  <TextInput
                    inputTitle={
                      batiment.equipments.equipmentlist.dilapidationcomment
                    }
                    textInput={dilapidationcomment}
                    handleTextInputChange={handleDilapidationcommentChange}
                  />

                  <AutocompleteTagsInput
                    inputTitle={
                      batiment.equipments.equipmentlist.otherproperties
                    }
                    list={autocompleteOptions}
                    selected={otherproperties}
                    handleChange={handleOtherpropertiesChange}
                  />
                </div>
                <div style={{ width: "98%" }}>
                  <AutocompleteInput
                    inputTitle={
                      batiment.equipments.equipmentlist.associatedfiles
                    }
                    selected={selectedGed()}
                    list={gedList}
                    handleChange={(_, newValue) =>
                      handleAssociatedfilesChange(newValue)
                    }
                  />

                  <TextInput
                    inputTitle={batiment.equipments.equipmentlist.comments}
                    textInput={comments}
                    handleTextInputChange={handleCommentsChange}
                  />

                  <TextInput
                    inputTitle={batiment.equipments.equipmentlist.description}
                    textInput={description}
                    handleTextInputChange={handleDescriptionChange}
                  />
                </div>
              </GridItem>
            </GridContainer>
          </form>
        </TabPanel>
        <TabPanel value="1">
          <form className={classes.root}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <div>
                  <CustomSelect
                    inputTitle={batiment.equipments.equipmentlist.device}
                    selectValue={device}
                    handleSelectValueChange={handleDeviceChange}
                    data={appareil}
                  />

                  <TextInput
                    inputTitle={batiment.equipments.equipmentlist.devicekey}
                    textInput={devicekey}
                    handleTextInputChange={handleDevicekeyChange}
                  />

                  <TextInput
                    inputTitle={batiment.equipments.equipmentlist.devicename}
                    textInput={devicename}
                    handleTextInputChange={handleDevicenameChange}
                  />

                  <TextInput
                    inputTitle={
                      batiment.equipments.equipmentlist.devicecategory
                    }
                    textInput={devicecategory}
                    handleTextInputChange={handleDevicecategoryChange}
                  />

                  <TextInput
                    inputTitle={
                      batiment.equipments.equipmentlist.devicetechnology
                    }
                    textInput={devicetechnology}
                    handleTextInputChange={handleDevicetechnologyChange}
                  />

                  <TextInput
                    inputTitle={batiment.equipments.equipmentlist.devicemodel}
                    textInput={devicemodel}
                    handleTextInputChange={handleDevicemodelChange}
                  />

                  <FloatInput
                    inputTitle={
                      batiment.equipments.equipmentlist.devicecaracteristicval
                    }
                    floatInput={devicecaracteristicval}
                    handleFloatInputChange={handleDevicecaracteristicvalChange}
                  />

                  <TextInput
                    inputTitle={
                      batiment.equipments.equipmentlist.devicecaracteristicunit
                    }
                    textInput={devicecaracteristicunit}
                    handleTextInputChange={handleDevicecaracteristicunitChange}
                  />

                  <FloatInput
                    inputTitle={
                      batiment.equipments.equipmentlist.deviceelectricalpower
                    }
                    floatInput={deviceelectricalpower}
                    handleFloatInputChange={handleDeviceelectricalpowerChange}
                  />

                  <FloatInput
                    inputTitle={
                      batiment.equipments.equipmentlist.devicethermicalpower
                    }
                    floatInput={devicethermicalpower}
                    handleFloatInputChange={handleDevicethermicalpowerChange}
                  />

                  <FloatInput
                    inputTitle={
                      batiment.equipments.equipmentlist.devicecoldpower
                    }
                    floatInput={devicecoldpower}
                    handleFloatInputChange={handleDevicecoldpowerChange}
                  />

                  <FloatInput
                    inputTitle={batiment.equipments.equipmentlist.devicecop}
                    floatInput={devicecop}
                    handleFloatInputChange={handleDevicecopChange}
                  />

                  <FloatInput
                    inputTitle={
                      batiment.equipments.equipmentlist.deviceefficiency
                    }
                    floatInput={deviceefficiency}
                    handleFloatInputChange={handleDeviceefficiencyChange}
                  />

                  <FloatInput
                    inputTitle={
                      batiment.equipments.equipmentlist.devicerateflow
                    }
                    floatInput={devicerateflow}
                    handleFloatInputChange={handleDevicerateflowChange}
                  />

                  <FloatInput
                    inputTitle={
                      batiment.equipments.equipmentlist.devicerenewalrateflow
                    }
                    floatInput={devicerenewalrateflow}
                    handleFloatInputChange={handleDevicerenewalrateflowChange}
                  />

                  <FloatInput
                    inputTitle={
                      batiment.equipments.equipmentlist.devicedimension
                    }
                    floatInput={devicedimension}
                    handleFloatInputChange={handleDevicedimensionChange}
                  />

                  <TextInput
                    inputTitle={batiment.equipments.equipmentlist.devicevalve}
                    textInput={devicevalve}
                    handleTextInputChange={handleDevicevalveChange}
                  />

                  <FloatInput
                    inputTitle={
                      batiment.equipments.equipmentlist.devicecarbonfootprint
                    }
                    floatInput={devicecarbonfootprint}
                    handleFloatInputChange={handleDevicecarbonfootprintChange}
                  />

                  <FloatInput
                    inputTitle={
                      batiment.equipments.equipmentlist.devicegreyenergy
                    }
                    floatInput={devicegreyenergy}
                    handleFloatInputChange={handleDevicegreyenergyChange}
                  />
                </div>
              </GridItem>
            </GridContainer>
          </form>
        </TabPanel>
      </div>
      <CreateButton buttonDisabled={false} handleSubmit={handleSubmit} />
    </TabContext>
  );
}

export default AddContractDialog;
